// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_DESCRIPTION_HEADER = "Popis";
export const BZ2_EDIT_ESHOP_URL_HEADER = "Webov\u00e1 adresa produktu";
export const BZ2_EDIT_PHOTO_HEADER = "Fotky";
export const BZ2_EDIT_PRICE_HEADER = "Cena";
export const BZ2_EDIT_SALARY_HEADER = "BZ2_EDIT_SALARY_HEADER";
export const BZ2_EDIT_SALARY_PER_HEADER = "BZ2_EDIT_SALARY_PER_HEADER";
export const BZ2_EDIT_SALARY_PER_HOUR = "BZ2_EDIT_SALARY_PER_HOUR";
export const BZ2_EDIT_SALARY_PER_MONTH = "BZ2_EDIT_SALARY_PER_MONTH";
export const BZ2_EDIT_TITLE_HEADER = "N\u00e1zev inzer\u00e1tu";
export const BZ2_FACET_CATEGORY = "Kategorie";
export const BZ2_FACET_COUNTRY = "Zem\u011b";
export const BZ2_FACET_COUNTY = "Okres";
export const BZ2_FACET_PLACE = "Obec";
export const BZ2_FACET_QUALITY2 = "Pou\u017eit\u00e9 zbo\u017e\u00ed / Vlastn\u00ed v\u00fdroba / Nov\u00e9 zbo\u017e\u00ed / Slu\u017eby";
export const BZ2_GET_PLAN = "Aktivuj si";
export const BZ2_HANDMADE_PRODUCT_HOVER = "Vlastn\u00ed v\u00fdroba";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00e9 zbo\u017e\u00ed";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00e9 zbo\u017e\u00ed";
export const BZ2_QUALITY_YOU_HAVE_count_OF_max = "(m\u00e1\u0161 %(count)s z %(max)s)";
export const BZ2_SERVICES_PRODUCT_HOVER = "Slu\u017eby";
export const BZ2_SUGGEST_CATEGORY_CATEGORY = "Doporu\u010den\u00e9 kategorie";
export const BZ2_UNLIMITED = "neomezen\u011b";
export const BZ_IN_STOCK_LABEL = "Zbo\u017e\u00ed m\u00e1m skladem (okam\u017eit\u011b k dispozici)";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_LARGE = "Max 3 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_MEDIUM = "Max 2 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_SMALL = "(mal\u00fd bal\u00edk)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_LARGE = "(t\u011b\u017e\u0161\u00ed boty, v\u011bt\u0161\u00ed koza\u010dky)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_MEDIUM = "(tenisky, baler\u00edny, boti\u010dky)";
export const BZ_PACKAGE_SIZE_ERROR_CHOOSE_SIZE = "Vyber velikost z\u00e1silky";
export const BZ_PACKAGE_SIZE_HEADER = "Velikost z\u00e1silky";
export const BZ_PACKAGE_SIZE_LARGE_detail = "Velk\u00e1 %(detail)s";
export const BZ_PACKAGE_SIZE_MEDIUM_detail = "St\u0159edn\u00ed %(detail)s";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const FORMS_DEFAULT_URL_FIELD_FORMAT_ERROR = "Toto nevypad\u00e1 jako spr\u00e1vn\u00e1 url adresa.";
export const HERE = "zde";
export const HOW_DOES_IT_WORK = "Jak to funguje?";
export const NEW_STROLLER_ONLY_WITH_XML_MOBILE_url = "Jen p\u0159es XML feed, v\u00edce informac\u00ed %(url)s";
export const NEW_STROLLER_ONLY_WITH_XML_url = "Lze p\u0159idat jen p\u0159es XML feed. V\u00edce informac\u00ed %(url)s";
export const PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY = "Chci vybrat jinou kategorii, uka\u017e mi v\u0161echny...";
export const PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS = "Hled\u00e1m kategorii...";
export const PRODUCT_CREATE_EDIT_FORM_PHOTOS_FAILED = "Fotky se nepoda\u0159ilo nahr\u00e1t. ";
export const PRODUCT_CREATE_EDIT_FORM_UPLOAD_SCREEN_INFO_icon = "%(icon)s je hlavn\u00ed fotka inzer\u00e1tu.";
export const PRODUCT_CREATE_EDIT_JOBS_CATEGORY_QUALITY = "Pr\u00e1ce a brig\u00e1dy mus\u00ed m\u00edt typ produktu Pr\u00e1ce.";
export const PRODUCT_CREATE_EDIT_JOBS_QUALITY_NEEDS_JOBS_CATEGORY = "Pr\u00e1ce mus\u00ed b\u00fdt v kategorii Pr\u00e1ce a brig\u00e1dy";
export const PRODUCT_CREATE_EDIT_MODEL_DO_NOT_MATCH_BRAND = "Vybran\u00fd model v dan\u00e9 zna\u010dce neexistuje\n";
export const PRODUCT_CREATE_EDIT_ONLY_ONE_VALUE_ALLOWED = "Povolen\u00e1 je pouze jedna vlastnost.";
export const PRODUCT_CREATE_EDIT_SERVICES_CATEGORY_QUALITY = "Slu\u017eby mus\u00ed m\u00edt typ produktu Slu\u017eba.";
export const PRODUCT_CREATE_EDIT_SERVICES_QUALITY_NEEDS_SERVICES_CATEGORY = "Slu\u017eby mus\u00ed b\u00fdt v kategorii Slu\u017eby";
export const SELECT_CATEGORY = "Vyber kategorii";
